import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** Wrapping slot holding a card's service metadata boxes. */
const CardDetailsContainer = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: 'flex',
				alignItems: 'center',
				flexWrap: 'wrap',
				gap: 300,
			},
			sx,
		)}
		{...rest}
	/>
);

export default CardDetailsContainer;
